const timestamp = () => {
  // const now = new Date();
  // const timestamp = now.toLocaleString();
  // console.log(timestamp);
  return new Date().toLocaleString();
};

export default timestamp;
